/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import { toAbsoluteUrl } from '../../../helpers'
import { fileBaseUrl } from '../../../../app/core/services/SERVICE-CONSTANTS'
import { Link } from 'react-router-dom'

const HeaderUserMenu: FC = () => {
  const { userInfo, logout } = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
      data-popper-placement='bottom-start'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={userInfo?.profileImage ? fileBaseUrl + userInfo?.profileImage : toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {userInfo?.firstName} {userInfo?.lastName}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                {
                  (userInfo?.userRoles?.find(a => a.role.name?.includes('admin')) || userInfo?.userRoles?.find(a => a.role.name?.includes('Management'))) && 'مدیریت'
                }
              </span>
            </div>
            <a className='fw-bold text-muted text-hover-primary fs-7'>
              {userInfo?.email || '---'}
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <Link to={`/edit-profile`} className='menu-link px-5'>
          پروفایل
        </Link>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          خروج
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
